export enum RedirectType {
  USER = 'USER',
  DRIVER = 'DRIVER',
  BOOKING = 'BOOKING',
  FAVORITE = 'FAVORITE',
  PURCHASE = 'PURCHASE',
  ACTIVE_PASS = 'ACTIVE_PASS',
  TRIP = 'TRIP',
  MESSAGE = 'MESSAGE',
  SUGGESTION = 'SUGGESTION',
  OBSERVATION = 'OBSERVATION',
  SUGGESTION_COMMENT = 'SUGGESTION_COMMENT',
  OBSERVATION_COMMENT = 'OBSERVATION_COMMENT',
  ROADMAP = 'ROADMAP',
}
